import React from 'react';

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { createDocumentFolder, getDocuments } from 'api/documents';
import Popup from 'components/Popup';
import SelectInput from 'components/Form/SelectInput';
import Button from 'components/Button';

export default function FolderAddDocumentPopup({
    visible,
    setVisible,
    present = [],
}) {

    const { folderId } = useParams();
    const cache = useQueryClient();

    const { mutate: update } = useMutation({
        mutationKey: ['updateFolder'],
        mutationFn: createDocumentFolder,
        onSuccess: () => {
            cache.invalidateQueries(['folders', folderId]);
            return setVisible(false);
        },
        onError: (error) => {
            console.error("Error updating folder:", error);
        }
    });

    const { data: documents } = useQuery({
        queryKey: ['documents'],
        queryFn: async () => await getDocuments({}),
    });

    const selectOptions = documents?.map(document => {
        return {
            value: document._id,
            label: document.name
        }
    });


    function onSubmitHandler(formData) {
        return update({
            data: {
                folder: folderId
            },
            id: formData.get('document')
        });
    }


    return (
        <Popup
            visible={visible}
            setVisible={setVisible}
        >
            <form action={onSubmitHandler} className='flex flex-col gap-4'>
                {selectOptions &&
                    <SelectInput
                        label="Seleziona cartella"
                        name="document"
                        options={selectOptions.filter(document => !present?.includes(document.value))}
                        required
                    />
                }

                <div className='flex justify-between gap-4 mt-6'>
                    <div onClick={() => setVisible(false)} className='hover:bg-verylight cursor-pointer px-4 py-3 text-sm rounded-sm'>
                        Annulla
                    </div>
                    <Button submit>Conferma</Button>
                </div>
            </form>
        </Popup>
    )
}
